export enum PublisherEmergencyStatus {
  Unknown = 0,
  Acknowledged = 1,
  Safe = 2,
}
